import { QueryClient } from '@tanstack/react-query';
import { ApiError } from '../fetcher/error';
import { HttpStatus } from 'src/shared/constants/httpStatus';
function retry(failureCount, error) {
    const maxRetries = 2;
    const isTotalOfFailuresLowerOrEqualMaxRetries = failureCount <= maxRetries;
    if (error instanceof ApiError) {
        const statusCode = error.statusCode;
        return ((statusCode < HttpStatus.BadRequest || statusCode >= HttpStatus.InternalServerError) &&
            isTotalOfFailuresLowerOrEqualMaxRetries);
    }
    return isTotalOfFailuresLowerOrEqualMaxRetries;
}
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry,
            refetchOnWindowFocus: false,
            // eslint-disable-next-line @typescript-eslint/no-magic-numbers
            staleTime: 10 * 60 * 1000 // 10 minutes
        }
    }
});
